import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {ANALYTIC_EVENTS, Analytics, useIVStore} from '@chekin/shared';
import {useGetGuestId} from '../../../hooks/useGetGuestId';
import {PATHS} from 'routes/constants';
import {Button, ResponsiveSheet} from '@chekinapp/ui';
import {useModalControls} from '@chekin/guestapp-ui-kit';

export type SkipIVModalRef = {
  open: (link?: string) => void;
};

const SkipIVModal = React.forwardRef<SkipIVModalRef, unknown>((_, ref) => {
  const {t} = useTranslation();
  const {
    isOpen: isOpenSkipVerificationModal,
    closeModal: closeSkipModal,
    openModal: openSkipModal,
  } = useModalControls();
  const guestId = useGetGuestId();
  const navigate = useNavigate();
  const {resetAllIVState} = useIVStore();

  const {getMainPath} = usePath();

  const onSkippedModal = React.useCallback(() => {
    const pathIdOrEmptyString = guestId || '';
    resetAllIVState();
    Analytics.track(ANALYTIC_EVENTS.ivSkipping);
    navigate(`${getMainPath(PATHS.addPersonalDataForm)}/${pathIdOrEmptyString}`);
  }, [resetAllIVState, navigate, getMainPath, guestId]);

  React.useImperativeHandle(
    ref,
    () => ({
      open: openSkipModal,
    }),
    [openSkipModal],
  );

  return (
    <ResponsiveSheet
      open={isOpenSkipVerificationModal}
      onClose={closeSkipModal}
      title={t('skip_verification_question')}
      closeOnOverlayClick
      contentClassName="px-6 pb-6 pt-4 sm:px-8 sm:pb-8 sm:pt-8"
      dialogClassName="!max-w-[460px]"
    >
      <div className="flex flex-col gap-8">
        <p className="text-sm text-gray-700">{t('skip_iv_process_text')}</p>
        <div className="flex flex-col gap-5 max-w-[375px] mx-auto">
          <Button onClick={onSkippedModal}>{t('skip_by_now')}</Button>
          <Button variant="link" onClick={closeSkipModal}>
            {t('continue_verification')}
          </Button>
        </div>
      </div>
    </ResponsiveSheet>
  );
});

export {SkipIVModal};
